import { Box, Typography } from '@mui/material';

import { AppHeader } from '../components/app-header';

/**
 * The unified search lives in AppHeader now, so this page is just a landing
 * surface — a hint pointing at the input above, and headroom for any future
 * admin dashboard widgets we want to add.
 */
export default function SearchPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Box sx={{ textAlign: 'center', mt: 8 }}>
          <Typography variant="h5" color="text.primary" gutterBottom>
            Admin search
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Use the search bar above to look up providers and organizations.
          </Typography>
          <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 1 }}>
            Tip: press <kbd>/</kbd> from anywhere to focus the search input.
          </Typography>
        </Box>
      </main>
    </div>
  );
}
